// packages/web/src/lib/api.ts
// REFACTORED: Now imports from modular structure
// This file maintains backward compatibility while delegating to focused modules

// Re-export everything from the new modular structure
export * from './api';
export * from './auth';
export * from './websocket';

// Legacy exports for backward compatibility
export { api } from './api/client';
export { apiFetch } from './api/fetch-helper';
export { setToken } from './auth/session-manager';
export { extractToken } from './auth/token-manager';
export { subscribeToOrderStatusUpdates, disconnectWebSocket } from './websocket/manager';

// Import ApiClient for circuit breaker protection
import { ApiClient } from './api/client';

// Business logic functions (maintained for backward compatibility)
export type FeeProfile = { name: string; processor_pct: number; flat_cents: number };

export async function getFeeProfiles(): Promise<{ items: FeeProfile[] }> {
  return ApiClient.get('/finance/fee-profiles') as Promise<{ items: FeeProfile[] }>;
}

export async function saveFeeProfile(p: FeeProfile): Promise<{ ok: boolean; item: FeeProfile }> {
  return ApiClient.put('/finance/fee-profiles', p) as any;
}

export async function getFeePreview(amountCents: number, method: 'card'|'ach'='card'):
  Promise<{ amountCents: number; processorFeeCents: number; totalFeesCents: number }> {
  return ApiClient.get(`/finance/fee-preview?amountCents=${amountCents}&method=${method}`) as any;
}

export type CatalogSettings = {
  show_managed: boolean;
  suppressed_ids: string[];
  allow_perks?: boolean;
};

export async function getCatalogSettings(): Promise<CatalogSettings> {
  return ApiClient.get('/catalog/settings') as Promise<CatalogSettings>;
}

export async function saveCatalogSettings(s: CatalogSettings): Promise<CatalogSettings> {
  return ApiClient.put('/catalog/settings', s) as Promise<CatalogSettings>;
}

export type OrdersQueueItem = {
  id: string; title: string; description?: string | null;
  progress?: number | null; status?: string | null;
  created_at?: string; customer_id?: string; quote_id?: string | null;
};

export async function getOrdersQueue(scope: 'partner'|'supplier'|'admin'='partner'):
  Promise<{ scope: string; items: OrdersQueueItem[] }> {
  return ApiClient.get(`/orders/queue?scope=${scope}`) as any;
}

export async function subscribeToOrder(
  id: string,
  payload: { channel: 'email'|'sms'; value: string }
) {
  return ApiClient.post(`/orders/${id}/subscribe`, payload);
}

export async function getInstallScore():
  Promise<{ score: number; components: Record<string, number>; updatedAt: string }> {
  return ApiClient.get('/partners/install-score') as any;
}
